import React from 'react'
import { TreeItem } from '@mui/x-tree-view/TreeItem'
import { Box, Typography, Radio, styled, useTheme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Icon } from '../../eid-icons'

const StyledRadio = styled(Radio)({
    padding: '2px',
    maxHeight: '20px',
    '&:hover': {
        backgroundColor: '#d2d2d9',
    },
})

const useStyles = makeStyles({
    root: {
        '&:focus > $content': {
            backgroundColor: 'inherit',
        },
        zIndex: 2000,
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        paddingLeft: '12px',
        marginLeft: 12,
        borderLeft: `1px dotted #eef0f4`,
    },
    content: {
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    label: (props) => ({
        width: 'max-content',
        borderRadius: '5px',
        color: props.radioSelection
            ? props.selected
                ? '#000000'
                : '#767676'
            : props.selected
            ? '#00bb75'
            : '#3b454d',
        backgroundColor: !props.radioSelection && 'unset !important',
        border:
            !props.radioSelection && props.selected
                ? 'solid 1px #00bb75'
                : 'none',

        padding: props.radioSelection ? '5px' : '0px',
        '&:hover': {
            backgroundColor: '#f1f1f4',
        },
        '& .search-highlight': {
            color: '#01745f',
            fontWeight: 600,
            textDecoration: 'underline',
        },
    }),
})

const highlight = (text, searchKey) => {
    searchKey = new RegExp('(' + searchKey + ')', 'gi')
    return text.split(searchKey).map((o, i) =>
        i % 2 === 1 ? (
            <span className="search-highlight" key={i}>
                {o}
            </span>
        ) : (
            o
        ),
    )
}

const MainTreeItem = ({
    index,
    label,
    count,
    highlightText,
    selected,
    onClick,
    radioSelection = true,
    iconUrl,
    ...rest
}) => {
    const classes = useStyles({ radioSelection, selected })
    const theme = useTheme()

    let labelToShow

    if (highlightText && highlightText.length) {
        labelToShow = highlight(label, highlightText)
    } else {
        labelToShow = label
    }

    return (
        <TreeItem
            classes={classes}
            {...rest}
            label={
                <Box
                    padding={radioSelection ? '0px' : '5px'}
                    display="flex"
                    height="100%"
                    alignItems="center"
                    onClick={(e) => {
                        if (!radioSelection) {
                            e.preventDefault()
                            onClick(e)
                        } else {
                            onClick(e)
                        }
                    }}
                >
                    {radioSelection && (
                        <StyledRadio
                            checkedIcon={
                                <Icon
                                    name="RadioFilled"
                                    color={theme.palette.primary.main}
                                />
                            }
                            icon={<Icon name="Radio" />}
                            checked={selected ?? false}
                            onClick={onClick}
                        />
                    )}
                    {iconUrl && (
                        <img
                            style={{ maxHeight: '16px' }}
                            src={iconUrl}
                            alt={'icon'}
                        />
                    )}
                    <Typography
                        variant="body2"
                        style={{
                            fontWeight: 'bold',
                            wordBreak: 'break-all',
                            paddingLeft: '12px',
                        }}
                    >
                        {labelToShow}
                    </Typography>
                    {count !== undefined && (
                        <Typography
                            variant="body2"
                            style={{ marginLeft: '5px', color: '#919193' }}
                        >
                            ({count})
                        </Typography>
                    )}
                    {!radioSelection && selected && (
                        <Box style={{ marginLeft: '17px', marginRight: '8px' }}>
                            <Icon name="Check" color={'#00bb75'} />
                        </Box>
                    )}
                </Box>
            }
        />
    )
}

export default MainTreeItem
